import type { GenerateProjectViewProjectOptions } from '../project-view-projects';
import { generateProjectViewProjectObject } from '../project-view-projects';
import type { ProjectViewProject } from '../project-view-projects/project-view-projects.model';

export function generateSuperuserProjectViewProjectObject(
  options: GenerateProjectViewProjectOptions,
): ProjectViewProject {
  return generateProjectViewProjectObject(options);
}
